import type Highcharts from 'highcharts';

export const HIGH_CHART_COMMON_OPTIONS: Highcharts.Options = {
	chart: {
		backgroundColor: 'transparent',
	},
};

export const HIGH_CHART_DARK_THEME: Highcharts.Options = {
	...HIGH_CHART_COMMON_OPTIONS,
	title: { style: { color: 'white' } },
	xAxis: { labels: { style: { color: 'white' } } },
	yAxis: { labels: { style: { color: 'white' } } },
	legend: { itemStyle: { color: 'white' } },
	tooltip: { backgroundColor: 'black', style: { color: 'white' } },
	exporting: {
		buttons: {
			contextButton: {
				theme: {
					fill: 'transparent',
				},
				symbolFill: '#000000',
				menuClassName:
					'bg-background p-0! text-foreground [&>ul]:bg-background! [&>ul>li]:hover:bg-card! [&>ul>li]:text-foreground!',
			},
		},
	},
};

export const HIGH_CHART_LIGHT_THEME: Highcharts.Options = {
  ...HIGH_CHART_COMMON_OPTIONS,
  title: { style: { color: 'black' } },
  xAxis: { labels: { style: { color: 'black' } } },
  yAxis: { labels: { style: { color: 'black' } } },
  legend: { itemStyle: { color: 'black' } },
  tooltip: { backgroundColor: 'white', style: { color: 'black' } },
};
